(() => {
  const ENGLAND_WALES_BANK_HOLIDAYS = new Set([
    "2026-01-01", "2026-04-03", "2026-04-06", "2026-05-04", "2026-05-25", "2026-08-31", "2026-12-25", "2026-12-28",
    "2027-01-01", "2027-03-26", "2027-03-29", "2027-05-03", "2027-05-31", "2027-08-30", "2027-12-27", "2027-12-28",
    "2028-01-03", "2028-04-14", "2028-04-17", "2028-05-01", "2028-05-29", "2028-08-28", "2028-12-25", "2028-12-26"
  ]);

  const pad = (value) => String(value).padStart(2, "0");
  const toIso = (date) => `${date.getUTCFullYear()}-${pad(date.getUTCMonth() + 1)}-${pad(date.getUTCDate())}`;
  const addDays = (date, days) => new Date(date.getTime() + days * 86400000);

  function londonNowParts(now = new Date()) {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      hourCycle: "h23"
    }).formatToParts(now).reduce((result, part) => {
      result[part.type] = part.value;
      return result;
    }, {});
    return {
      date: new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12)),
      hour: Number(parts.hour)
    };
  }

  function addWorkingDays(date, numberOfDays) {
    let candidate = date;
    let added = 0;
    while (added < numberOfDays) {
      candidate = addDays(candidate, 1);
      const day = candidate.getUTCDay();
      if (day !== 0 && day !== 6 && !ENGLAND_WALES_BANK_HOLIDAYS.has(toIso(candidate))) added += 1;
    }
    return candidate;
  }

  function earliestDeliveryDate(now = new Date(), cutoffHour = 10) {
    const london = londonNowParts(now);
    const orderDay = london.date.getUTCDay();
    if (orderDay === 0 || orderDay === 6) {
      const processingDate = addWorkingDays(london.date, 1);
      return addWorkingDays(processingDate, 1);
    }
    return addWorkingDays(london.date, london.hour < Number(cutoffHour) ? 1 : 2);
  }

  function formatDeliveryDate(date) {
    return date.toLocaleDateString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "long",
      timeZone: "UTC"
    });
  }

  function initialiseBanners(root = document) {
    root.querySelectorAll("[data-product-delivery-from]").forEach((banner) => {
      const cutoffHour = Number(banner.dataset.cutoffHour || 10);
      const london = londonNowParts();
      const orderDay = london.date.getUTCDay();
      const isWeekendOrder = orderDay === 0 || orderDay === 6;
      banner.querySelector("[data-product-delivery-date]").textContent = formatDeliveryDate(earliestDeliveryDate(new Date(), cutoffHour));
      banner.querySelector("[data-product-delivery-cutoff]").textContent = isWeekendOrder
        ? "Weekend orders are processed from the next working day. Mainland UK estimate; service and postcode dependent."
        : london.hour < cutoffHour
        ? `Order before ${cutoffHour}am. Mainland UK estimate; service and postcode dependent.`
        : `Today's ${cutoffHour}am cutoff has passed. Mainland UK estimate; service and postcode dependent.`;
    });
  }

  window.ReinforcedBedsProductDeliveryFrom = {
    toIso,
    londonNowParts,
    addWorkingDays,
    earliestDeliveryDate,
    formatDeliveryDate
  };

  if (typeof document !== "undefined") {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initialiseBanners());
    else initialiseBanners();
    document.addEventListener("shopify:section:load", (event) => initialiseBanners(event.target));
  }
})();
